import { useEffect } from 'react'
import { FormikState, FormikValues } from 'formik'

const useAutoSelectPhoneCodeByCountry = (
    setFormikState: (
        f:
            | FormikState<FormikValues>
            | ((prevState: FormikState<FormikValues>) => FormikState<FormikValues>),
        cb?: () => void,
    ) => void,
    locationData,
    phoneData,
) => {
    useEffect(() => {
        const locationCountryCode = locationData.country?.isoCode
        if (!locationCountryCode) return

        setFormikState((prevState: FormikState<any>) => ({
            ...prevState,
            values: {
                ...prevState.values,
                phoneData: {
                    ...phoneData,
                    pendingChange: {
                        countryCode: locationCountryCode,
                    },
                },
            },
        }))
    }, [locationData?.country?.isoCode])
}

export { useAutoSelectPhoneCodeByCountry }
